module.exports = __webpack_public_path__ + "static/media/totaldrama.3e307d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/totaldrama/totaldrama.png
// module id = 747
// module chunks = 0